export const Validations = {
     required: "required",
     pattern: "pattern",
     message: "message",
     regex: "regex",
     noSpace: "noSpace"
}

export const noSpaceValidator = value => value?.trim().length > 0;